import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Modal,
  Spinner,
  Alert,
} from "react-bootstrap";
import { userTaleListByType } from "../../../api/taleService";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";
import bookimg1 from "../../../assets/img/bookimg1.jpg"; // Fallback image

const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";
const THUMB_URL = "https://d2wkfbkx3no0o5.cloudfront.net/";

const getImageUrl = (book) => {
  if (book.fileType?.includes("video")) {
    return `${THUMB_URL}${book.thumbnail}`;
  }
  return `${MEDIA_URL}${book.file}`;
};

export default function TaleTab() {
  const [searchText, setSearchText] = useState("");
  const [uploadType, setUploadType] = useState("");
  const [userTaleList, setUserTaleList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const { userId } = useParams();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (userId) fetchUserTales();
  }, [userId, uploadType]);

  const fetchUserTales = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await userTaleListByType({
        userId,
        title: searchText.trim(),
        uploadType,
      });

      if (response?.data) {
        setUserTaleList(response.data);
      } else {
        setError("Failed to retrieve tales. Please try again later.");
      }
    } catch (err) {
      console.error("Error fetching tales:", err);
      setError("An error occurred while fetching tales.");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Title",
     minWidth: "300px",
      wrap: true,
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => (
        <>
          <img
            src={getImageUrl(row)}
            className="table_img rounded-circle img-thumbnail me-2"
            alt={row.title}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = bookimg1;
            }}
            width={50}
            height={50}
            style={{ objectFit: "cover" }}
          />
          {row.title}
        </>
      ),
    },
    {
    name: "Characters",
    selector: (row) => Array.isArray(row.characters) ? row.characters.length : 0,
    sortable: true,
    center: true,
    width: "150px",
  },
    {
    name: "Date Created",
    selector: (row) => row.createdAt,
    sortable: true,
    wrap: true,
    minWidth: "200px",
    cell: (row) =>
      new Date(row.createdAt).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
  },
  {
    name: "Actions",
    center: true,
    width: "120px",
    cell: (row) => (
      <>
        <Link className="btnview me-2" to={`/admin/tale-detail/${row._id}`}>
          <Icon icon="tabler:eye" />
        </Link>
        {/* <span className="btndelete" onClick={handleShow}>
          <Icon icon="tabler:trash" />
        </span> */}
      </>
    ),
  },
  ];

  const filteredData = userTaleList.filter((item) =>
    JSON.stringify(item).toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Card>
        <Card.Body className="bookingtable mt-3">
          <div className="d-flex gap-3 flex-wrap justify-content-between mb-3">
            <div className="tableselectTypefield">
              <Form.Select
                value={uploadType}
                onChange={(e) => setUploadType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="ShortTale">Short Tales</option>
                <option value="UploadTale">Upload Tales</option>
                <option value="AiGeneratedTale">AI Generated Tales</option>
              </Form.Select>
            </div>
            <div className="text-end">
              <input
                type="text"
                placeholder="Search..."
                className="searchfield"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>

          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              responsive
              className="custom-table"
              noDataComponent={
                <p className="text-center my-4">No tales found</p>
              }
            />
          )}
        </Card.Body>
      </Card>

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            onClick={handleClose}
            className="btn btn-primary-outline px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            onClick={handleClose}
            className="btn btn-primary px-4 min_width110"
          >
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
